export enum SAVE_SKETCH_TYPE {
  PLANE = 'PLANE',
  ALL = 'ALL',
}
